import styled from 'styled-components';

const mobileBreakpoint = '1000px';

export const TilesSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 40px;
  background-color: #FFF;
  justify-content: center;
  align-items: center;

  @media (min-width: 1200px) {
	padding: 90px 40px 60px;
  }
  
  @media (max-width: 1000px) {
	padding: 26px 20px;
  }
`;

export const TilesTitle = styled.div`
  text-transform: uppercase;
  color: #595959;
  font-family: Champion, sans-serif;
  font-size: 24px;
  line-height: 24px;
  text-align: center;

  @media (min-width: 1200px) {
	font-size: 48px;
	line-height: 38px;
  }
  
  @media screen and (max-width: ${mobileBreakpoint}) {
	padding: 0 40px;
	color: #000000;
	font-family: Barlow, sans-serif;
	font-size: 24px;
	font-weight: 600;
	letter-spacing: 0;
	line-height: 25px;
	text-align: center;
  }`;

export const TilesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
  
  > div {
	width: 33%;
  }

  @media (min-width: 1200px) {
	flex-direction: row;
	margin-top: 85px;
	align-items: flex-start;
  }

  @media screen and (max-width: 1000px) {
	> div {
	  width: 100%;
	}
  }
`;

export const LogosWrapper = styled.div`
  margin: 0 auto 36px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 36px;
  
  div {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	
	img {
	  height: 44px;
	  width: auto;
	}
	
	h3 {
	  color: #FFFFFF;
	  font-family: Eund, sans-serif;
	  font-size: 24px;
	  letter-spacing: 0;
	  line-height: 29px;
	  font-weight: normal;
	  margin-bottom: 6px;
	}
  }
  
  @media screen and (max-width: 1000px) {
	margin: 0 auto;
  }
`;
